import React from "react";
import { Card, CardBody } from "reactstrap";
import CptShimmerBlock from "../CptShimmerBlock";

const NaKpiCardShimmer = () => (
  <Card className="stat-card-simple na-kpi mpr-shimmer-shell-card">
    <CardBody>
      <div className="stat-content">
        <CptShimmerBlock className="mpr-shimmer-stat-label-line" />
        <CptShimmerBlock className="mpr-shimmer-stat-value-line" />
      </div>
      <CptShimmerBlock className="mpr-shimmer-stat-icon-wrap" />
    </CardBody>
  </Card>
);

export default NaKpiCardShimmer;
